<template>
  <div class="modal-card">
    <header class="modal-card-head">
        <p class="modal-card-title has-text-white">Elevate A User to Admin</p>
        <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
    </header>   
    <section class="modal-card-body has-background-dvodark">
      <div class="">
        <b-field label="Enter Users To Add Admin Privleges To">
            <b-taginput
                v-model="selectedUser"
                :data="filteredUsers"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="email"
                icon="label"
                @typing="getFilteredUsers"
                :loading="isSending">
            </b-taginput>
        </b-field>
        <b-button 
            class="is-primary mt-4" 
            :disabled="isSending"
            @click="addToAdmin()">
            Add Admin Privledges
        </b-button>
      </div>
    </section>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { addToAdmin } from '../graphql/mutations'
import { personReader } from '../graphql/queries'

export default {
    data(){
        return{
            users: [],
            filteredUsers: [],
            selectedUser: null,
            isSending: false
        }
    },
    methods: {
        async addToAdmin() {
            this.isSending = true
            for(let i = 0; i < this.selectedUser.length; i++){
            await API.graphql({
                query: addToAdmin,
                variables: {
                    input: {
                    username: this.selectedUser[i].cognito_id,
                    request_type:"create"
                    }
                }
            }).then((res) => 
                {
                    console.log(res)
                    this.$buefy.notification.open({
                        duration: 10000,
                        message: `Admin added succesfully`,
                        position: 'is-bottom',
                        type: 'is-success',
                        hasIcon: true
                    })
                }).catch((e) => {
                    console.log(e)
                    this.$buefy.notification.open({
                        duration: 10000,
                        message: `${e.errors[0].message}`,
                        position: 'is-bottom',
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            }
            this.selectedUser = [];
            this.isSending = false
        },
        async getUsers() {
            const Users = await API.graphql({
                query: personReader,
                variables: {
                    input: {
                        request_type: 'read_all'
                    }
                }
            });
            this.users = Users.data.personReader;
        },
        getFilteredUsers(text) {
                this.filteredUsers= this.users.filter((option) => {
                    return option.email
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
        })
        },
        openNotification() {
            this.$buefy.notification.open({
                duration: 10000,
                message: `Admin added succesfully`,
                position: 'is-bottom',
                type: 'is-success',
                hasIcon: true
            })
        }
    },
    mounted(){
        this.getUsers()
    }
}
</script>

<style>

</style>